import type { RootState } from '../store'
import type { Task } from '../../Models/Task'

export const selectAllTasks = (state: RootState): Task[] => state.tasks.items

export const selectTaskById =
  (id: string | undefined) =>
  (state: RootState): Task | undefined =>
    id ? state.tasks.items.find((t) => t.id === id) : undefined

export const selectTasksForDate =
  (scheduledDate: string) =>
  (state: RootState): Task[] =>
    state.tasks.items.filter((t) => t.scheduledDate === scheduledDate)

export const selectTasksStatus = (state: RootState) => state.tasks.status

/**
 * Search semantics:
 * - Empty query: no results.
 * - Query starting with `#`: exact (case-insensitive) match against any stored tag in `labels`.
 *   Tags are stored without the `#` — the leading `#` is a UI-only signal.
 * - Otherwise: substring (case-insensitive) match against `title`.
 */
export const selectSearchedTasks =
  (query: string) =>
  (state: RootState): Task[] => {
    const raw = query.trim()
    if (!raw) return []

    const sortByCreatedDesc = (a: Task, b: Task) => (a.createdAt < b.createdAt ? 1 : -1)

    if (raw.startsWith('#')) {
      const needle = raw.slice(1).trim().toLowerCase()
      if (!needle) return []
      return state.tasks.items
        .filter((t) =>
          (t.labels ?? []).some((l) => l.trim().toLowerCase() === needle)
        )
        .slice()
        .sort(sortByCreatedDesc)
    }

    const titleNeedle = raw.toLowerCase()
    return state.tasks.items
      .filter((t) => t.title.toLowerCase().includes(titleNeedle))
      .slice()
      .sort(sortByCreatedDesc)
  }
